import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import GeneralTerms from './general-terms';
import {
  fetch
} from 'redux/modules/general-terms';

export class GeneralTermsContainer extends React.Component {

  static propTypes = {
    generalTerms: React.PropTypes.object.isRequired,
    i18n: React.PropTypes.object.isRequired,
    fetch: React.PropTypes.func
  };

  componentDidMount () {
    if (_.isEmpty(this.props.generalTerms.headline)) {
      this.fetchGeneralTerms();
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!_.isEqual(nextProps.i18n, this.props.i18n)) {
      this.fetchGeneralTerms();
    }
  }

  fetchGeneralTerms () {
    let languageId = this.props.i18n.locale === 'se' ? 1 : 3;
    this.props.fetch(languageId);
  }

  render () {
    return <GeneralTerms generalTerms={this.props.generalTerms} />;
  }
}

function mapStateToProps (state) {
  return {
    i18n: state.i18n,
    generalTerms: state.generalTerms.entity
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: (language) => dispatch(fetch(language))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralTermsContainer);




/** WEBPACK FOOTER **
 ** ./src/components/general-terms/general-terms-container.js
 **/